module.exports = __webpack_public_path__ + "static/media/cap1-04-mob.5c7242a9.png";